import { useState, useEffect, useCallback } from "react";
import { debounce } from "@/utils";
type position = {
    x: number,
    y: number
}


export function useScroll() {
    const [{ x, y }, setPosition] = useState<position>({x: 0, y: 0})

    const fn = debounce(()=> {
        const position = {
            x: window.scrollX,
            y: window.scrollY
        }
        setPosition(position)
    }, 100)

    const addScrollEvent = ()=> {
        window.addEventListener("scroll", fn)
    }
    // 清除事件
    const clear = ()=> {
        window.removeEventListener('scroll', fn)
    }
    useEffect(()=> {
        addScrollEvent()
        // console.log('document.getElementById productSpecifications', document.getElementById('productSpecifications'))
        return ()=> {
            clear()
        }
    }, [])
    return { x, y, clear}
}